import {
  Box,
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  Typography,
  TypographyProps,
} from '@mui/material';
import { useIsSubscriber } from '../useIsSubscriber';
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';

const WhiteBGTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#fff',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: theme.typography.pxToRem(12),
    width: '400px',
    borderRadius: '8px',
    boxShadow: '0px -2px 11px 3px #00000026',
    border: '1px solid #fafafa',
  },
  // arrow white background
  [`& .${tooltipClasses.arrow}`]: {
    color: '#fff',
    '&::before': {
      backgroundColor: '#fff',
      border: '1px solid #fff',
      transform: 'rotate(45deg)',
    },
  },
}));

const PaperAccountHeader = (props: TypographyProps) => {
  const isSubscriber = useIsSubscriber();
  const router = useNavigate();

  if (!isSubscriber) {
    return null;
  }

  return (
    <WhiteBGTooltip
      title={
        <Box sx={{ padding: '8px', backgroundColor: 'white' }}>
          <Typography mb={1} fontWeight={600} fontSize={19}>
            Ready to trade with real money?
          </Typography>

          <Typography mb={2} fontWeight={300} fontSize={12}>
            We’ve partnered with Tradier to bring you live trading.{' '}
          </Typography>

          <Typography mb={3} fontWeight={300} fontSize={12}>
            <a
              rel="noreferrer"
              target="_blank"
              href="https://trade.tradier.com/optionsai/"
              style={{
                color: '#007bff',
                cursor: 'pointer',
                textDecoration: 'underline',
              }}
            >
              Learn how to activate your account →
            </a>
          </Typography>
        </Box>
      }
      placement="top"
      arrow
      enterDelay={100}
      leaveDelay={300}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: 'rgba(29, 29, 120, 0.1)',
          justifyContent: 'center',
          padding: '6px 12px',
          borderRadius: '4px',
          // cursor: 'pointer',
        }}
        // onClick={() => router('/account')}
        {...props}
      >
        <Typography
          fontWeight={'600'}
          color="rgba(29, 29, 120, 1)"
          variant="body2"
        >
          Paper Trade
        </Typography>
      </Box>
    </WhiteBGTooltip>
  );
};

export default memo(PaperAccountHeader);
